import React, { memo, ReactNode, useContext } from 'react';
import { DOMProps } from '@react-types/shared';

import { TestProps } from '../../../internal/types/testTypes';
import { cn } from '../../../lib/css/className/className';
import './ListInputItem.css';
import { ListContext } from '../utils';
import { TextInput, TextInputProps } from '../../TextInput';
import { ListBaseItem, ListBaseItemProps } from '../ListBaseItem/ListBaseItem';

const cls = cn('ListInputItem');

export interface ListInputItemProps
    extends Omit<ListBaseItemProps, 'children'>,
        Pick<TextInputProps, 'value' | 'onChange' | 'placeholder'>,
        TestProps,
        DOMProps {
    /**
     * Функция для переопределения рисуемого инпута
     * @default TextInput
     * @example props => <MaskedTextInput {...props} hasClearButton />
     */
    children?: (props: TextInputProps) => ReactNode;
}

const defaultRenderer = (props: TextInputProps) => <TextInput {...props} />;

/**
 * Компонент для создания элемента с инпутом внутри
 */
export const ListInputItem = memo<ListInputItemProps>(function ListInputItem(props) {
    const { children = defaultRenderer, className, ...inputProps } = props;
    const { size } = useContext(ListContext);

    return (
        <ListBaseItem className={cls('', [className])}>
            <div className={cls('input')}>
                {children({
                    ...inputProps,
                    size,
                    color: 'transparent',
                })}
            </div>
        </ListBaseItem>
    );
});
